/**
 * mamacool-status.js
 * ─────────────────────────────────────────────────────────────────
 * Handles Pre-Order / Coming Soon button relabelling on:
 *   - Collection pages
 *   - Home page product grids
 *   - Product detail pages (PDP)
 *
 * Works by reading data-mc-status attributes set by the Liquid snippet
 * (card pages) or window.mcProductStatus (PDP, set inline in product.json).
 * ─────────────────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  var LABELS = {
    'pre-order':   'Pre-Order',
    'coming-soon': 'Coming Soon'
  };

  /* ── Card pages (collection / home) ──────────────────────────── */
  function processCards() {
    var cards = document.querySelectorAll('[data-mc-status]');

    cards.forEach(function (card) {
      var status = card.getAttribute('data-mc-status');
      if (!status || !LABELS[status]) return;

      var label = LABELS[status];

      /* Rewrite quick-add / card button text */
      var btns = card.querySelectorAll(
        '.card__button, .quick-add__submit, .quick-add button'
      );
      btns.forEach(function (btn) {
        /* Preserve any SVG icons inside the button */
        var svgs = btn.querySelectorAll('svg');
        btn.textContent = label;
        svgs.forEach(function (svg) { btn.appendChild(svg); });

        if (status === 'coming-soon') {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('aria-disabled', 'true');
        }
      });
    });
  }

  /* ── Product Detail Page ──────────────────────────────────────── */
  function processPDP() {
    /* The PDP status is set by a small inline script in product.liquid
       (see installation instructions). Falls back to scanning page tags. */
    var status = window.mcProductStatus || null;

    if (!status) return;
    if (!LABELS[status]) return;

    var label = LABELS[status];

    /* Flag the body so CSS can target PDP buttons */
    document.body.setAttribute('data-mc-pdp-status', status);

    /* Rewrite the main add-to-cart button */
    var addBtns = document.querySelectorAll(
      '.product-form__submit, button[name="add"]'
    );
    addBtns.forEach(function (btn) {
      var svgs = btn.querySelectorAll('svg');
      /* Fable theme uses data-add-to-cart-text on the button span */
      var span = btn.querySelector('[data-add-to-cart-text]');
      if (span) {
        span.textContent = label;
      } else {
        btn.childNodes.forEach(function (node) {
          if (node.nodeType === Node.TEXT_NODE) node.textContent = '';
        });
        var textSpan = document.createElement('span');
        textSpan.textContent = label;
        btn.insertBefore(textSpan, btn.firstChild);
      }
      svgs.forEach(function (svg) { btn.appendChild(svg); });

      /* Note text is resolved per country in Liquid
         (custom-mamacool-status-resolve.liquid) and handed over via
         window.mcPreorderNote; empty means no note. */
      var noteText = typeof window.mcPreorderNote === 'string' ? window.mcPreorderNote : '';

      if (status === 'coming-soon') {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');

        /* Add helper note below button */
        var form = btn.closest('form');
        if (form && !form.querySelector('.mc-coming-soon-note')) {
          var note = document.createElement('span');
          note.className = 'mc-coming-soon-note';
          note.textContent = noteText || 'This product is coming soon — check back shortly!';
          form.appendChild(note);
        }
      }

      if (status === 'pre-order' && noteText) {
        /* Add shipping note below button */
        var form = btn.closest('form');
        if (form && !form.querySelector('.mc-pre-order-note')) {
          var note = document.createElement('span');
          note.className = 'mc-pre-order-note';
          note.textContent = noteText;
          form.appendChild(note);
        }
      }
    });
  }

  /* ── Init ─────────────────────────────────────────────────────── */
  function init() {
    processCards();
    processPDP();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run if Shopify sections are dynamically reloaded in the editor */
  document.addEventListener('shopify:section:load', init);

})();